import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Header from './components/Header';
import Landing from './components/Landing';
import About from './components/About';
import Skills from './components/Skills';
import Portfolios from './components/Portfolios';
import Contacto from './components/Contacto';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  return (
    <div className="App">
     <Header />
     <Landing />
     <About />
     <Skills />
     <Portfolios />
     <Contacto />
    </div>
  );
}

export default App;
